import { DesignLayoutType } from '@graphql/generated-base';
import React from 'react';
import { UnlockDialogProvider } from '../UnlockDialog/UnlockDialogProvider';
import { EventTopBar } from '../EventTopBar';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import { LayoutProvider } from '@shared/context/LayoutProvider';

interface StandAloneAlohaMenuProps
  extends Readonly<{
    readonly eventHandle: string;
  }> {}

export const StandAloneAlohaMenu: React.FC<StandAloneAlohaMenuProps> = ({ eventHandle }) => {
  const isMobile = useIsMobileScreen();

  if (isMobile) {
    return null;
  }

  return (
    <LayoutProvider layout={DesignLayoutType.aloha}>
      <UnlockDialogProvider>
        <EventTopBar eventHandle={eventHandle} />
      </UnlockDialogProvider>
    </LayoutProvider>
  );
};
